import { useEffect } from 'react';
import { Button, styled } from '@fhl-world/salmon-ui';
import { logout } from '@fhl-world/auth-core/webpack-esm';
import { track } from '@amplitude/analytics-browser';

import { useAsyncAction } from '@api/services/utilsService/utilsApiService';
import { UserData } from '@api/models/user';
import { AmplitudeEvents } from '@utils/amplitudeEvents';
import ProfileElement from './ProfileElement';

interface ProfileData {
	profileData: UserData;
}

const Title = styled('h3')`
	font-size: 24px;
	font-weight: 800;
	line-height: 28px;
	margin: 0;
`;

const LogOutButtonWrapper = styled('div')`
	padding-top: 72px;
`;

const LogOutButton = styled(Button)`
	font-size: 15px;
	font-weight: 800;
	line-height: 24px;
	text-transform: none;
`;

function Profile(props: ProfileData) {
	const { email, fullName, phone } = props.profileData;
	const [{ loading }, logoutFn] = useAsyncAction(logout);

	useEffect(() => {
		track(AmplitudeEvents.Profile_Opened);
	}, []);

	return (
		<div>
			<Title>Profile</Title>
			<ProfileElement caption={'Full name'} data={fullName} />
			<ProfileElement caption={'Telephone number'} data={phone} />
			<ProfileElement caption={'E-mail'} data={email} />

			<LogOutButtonWrapper>
				<LogOutButton
					disabled={loading}
					onClick={() => {
						track(AmplitudeEvents.LogOut_Tap);
						logoutFn();
					}}
				>
					Log out
				</LogOutButton>
			</LogOutButtonWrapper>
		</div>
	);
}

export default Profile;
